import { Backdrop, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import { useState } from "react";

import { layoutPrivateStyle } from "../../../styles/layout/private-routes";
import { SideMenuPrivateRoute } from "../side-menu";
import { Header } from "./header";
import { SideMenuAdmin } from "./sidemenu-admin";

export function LayoutPrivateRoute({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [adminMenu, setAdminMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState("/dashboard/editor");

  return (
    <Box component="main" sx={layoutPrivateStyle.privateRoutes}>
      <Header mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} />
      <Stack direction="row" sx={layoutPrivateStyle.privateRoutesSideMenu}>
        <SideMenuAdmin
          adminMenu={adminMenu}
          setAdminMenu={setAdminMenu}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
        />
        {children}
      </Stack>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={mobileMenu}
        onClick={() => setMobileMenu?.(!mobileMenu)}
      >
        <Box sx={layoutPrivateStyle.privateRoutesCandyBox}>
          <SideMenuPrivateRoute
            mobileMenu={mobileMenu}
            setMobileMenu={setMobileMenu}
          />
        </Box>
      </Backdrop>
    </Box>
  );
}

export default LayoutPrivateRoute;
